import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { combineLatest } from 'rxjs';
import { take } from 'rxjs/operators';

import { RFP_SUBJECT, VALIDATORS } from 'app/constants';
import { Account } from 'graphql/models/generated';
import { DropdownItem } from 'models/dropdown.model';
import { AccountService } from 'shared/services/account.service';
import { StoreService } from 'shared/services/store.service';

/**
 * RFP = Request For Price
 */
@Component({
  selector: 'app-rfp',
  templateUrl: './rfp.component.html'
})
export class RfpComponent implements OnInit {
  form!: UntypedFormGroup;

  formReady = false;

  dropdownData: Record<string, any> = {
    subject: RFP_SUBJECT,
    manufacturers: [] as DropdownItem[]
  };

  manufacturer!: string;

  constructor(
    private fb: UntypedFormBuilder,
    private storeService: StoreService,
    private translateService: TranslateService,
    private accountService: AccountService
  ) { }

  ngOnInit(): void {
    this.init();
  }

  private init(): void {
    combineLatest([
      this.storeService.getAccountManufacturer(),
      this.accountService.getManufacturerAccountsForRFP()
    ]).pipe(take(1))
      .subscribe(([manufacturer, accounts]: [string, Account[]]) => {
        const translateKey = `GENERAL.MANUFACTURER.${manufacturer.toUpperCase()}`;

        this.manufacturer = this.translateService.instant(translateKey);
        this.dropdownData.manufacturers = this.accountService.mapAccountsToDropdown(accounts);
      });

    this.setupForm();
  }

  setupForm(): void {
    this.storeService.setFormReady(false);

    this.form = this.fb.group({
      subject: ['Anfrage von', Validators.required],
      email: ['', [Validators.pattern(VALIDATORS.PATTERN.MAIL), Validators.required]],
      message: ['', [Validators.maxLength(VALIDATORS.MAX_LENGTH.TEXTAREA), Validators.required]]
    }, { updateOn: 'blur' });

    this.formReady = true;
    this.storeService.setFormReady(this.formReady);
  }
}
